export default "__VITE_ASSET__uxX0O76c__"